import React, {Fragment} from 'react';
import {translate} from "react-i18next";
import PageHeader from "../../components/elements/PageHeader";
import ProjectStatsApi from "../../apis/ProjectStatsApi";
import moment from 'moment';
import Plotly from 'plotly.js-basic-dist';
import localeDE from 'plotly.js-locales/de';
import {connect} from "react-redux";

class ProjectStats extends React.Component {

    state = {
        loading: true,
        projectStats: null
    };

    componentDidMount() {
        ProjectStatsApi.getProjectStats()
            .then((response) => {
                this.setState({
                    loading: false
                });
                if (response.status === 200) {
                    this.setState({
                        projectStats: response.data.data
                    });
                }
            });
        Plotly.register(localeDE);
        Plotly.setPlotConfig({locale: 'de'})
    }

    render() {
        const {t} = this.props;
        var currencyFormatter = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
        });
        let hoursPerWorkTypePerDayDays, hoursPerWorkTypePerDayWorkTypes, slotsPerHourPerWorkType;
        if (this.state.projectStats) {
            hoursPerWorkTypePerDayDays = this.state.projectStats.hoursPerWorkTypePerDay.map(el => el[1]).filter((v, i, a) => a.indexOf(v) === i).map(el => moment(el, 'YYYY-MM-DD'));
            hoursPerWorkTypePerDayWorkTypes = this.state.projectStats.hoursPerWorkTypePerDay.map(el => el[0]).filter((v, i, a) => a.indexOf(v) === i);
            if (this.state.projectStats.slotsPerHourPerWorkType && this.state.projectStats.slotsPerHourPerWorkType.length > 0) {
                slotsPerHourPerWorkType = {
                    plotData: Object.keys(this.state.projectStats.slotsPerHourPerWorkType[0].result).map(key => ({
                        x: this.state.projectStats.slotsPerHourPerWorkType.map(el => el.date),
                        y: this.state.projectStats.slotsPerHourPerWorkType.map(el => el.result[key]),
                        name: key,
                        type: 'scatter'
                    })),
                    layout: {
                        xaxis: {
                            tickformat: '%a (%d.%m.)\n%H:%M'
                        }
                    }
                };
                setTimeout(() => {
                    Plotly.newPlot('plot-slotsPerHourPerWorkType', slotsPerHourPerWorkType.plotData, slotsPerHourPerWorkType.layout, {locale: 'de'})
                }, 500);
            }
        }
        return (
            <div className="ProjectStats">
                <PageHeader title={t('projectStats.title')} loading={this.state.loading}/>
                {this.state.projectStats ? (
                    <Fragment>
                        <div className="row m-t">
                            <div className="col-xs-12 col-md-6">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h4>{t('projectStats.hoursPerWorkType.title')}</h4>
                                    </div>
                                    <div className="ibox-content">
                                        <table className="table table-bordered table-striped">
                                            <thead>
                                            <tr>
                                                <th>
                                                    {t('projectStats.hoursPerWorkType.table.workType')}
                                                </th>
                                                <th>
                                                    {t('projectStats.hoursPerWorkType.table.hours')}
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.projectStats.hoursPerWorkType.map((hpwt, hpwtI) => (
                                                <tr key={hpwtI}>
                                                    <td>
                                                        {hpwt[0]}
                                                    </td>
                                                    <td className="text-right">
                                                        {hpwt[1]}
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row m-t">
                            <div className="col-xs-12 col-md-12">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h4>{t('projectStats.expensesPerCompanyAndWorkType.title')}</h4>
                                    </div>
                                    <div className="ibox-content">
                                        <table className="table table-bordered">
                                            <thead>
                                            <tr>
                                                <th>
                                                    {t('companies.table.header.name')}
                                                </th>
                                                {this.state.projectStats.workTypes.map((hpwt, hpwtI) => (
                                                <th key={hpwtI} className="text-right">
                                                    {hpwt[0]}
                                                </th>
                                                ))}
                                                <th className="text-right">
                                                    {t('projectStats.expenses.total')}
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.projectStats.expensesForAllCompanies.map((eFAC, eFACI) => (
                                                <tr key={eFACI}>
                                                    <td>
                                                        {this.props.company.companies.find(el => el.id === eFAC[0]).name}
                                                    </td>
                                                    {this.state.projectStats.workTypes.map((wt, wtI) => (
                                                        <td key={wtI} className="text-right">
                                                            {eFAC[1].find(el => el[0] === wt[0]) ? (
                                                                <span>{(currencyFormatter.format((eFAC[1].find(el => el[0] === wt[0]))[1]))}</span>
                                                            ) : (
                                                                <span>{currencyFormatter.format(0)}</span>
                                                            )}
                                                        </td>

                                                    ))}
                                                    <td className="font-bold text-right">
                                                        {(currencyFormatter.format(this.state.projectStats.expensesPerCompany.find(el => el[0] === eFAC[0])[1]))}
                                                    </td>
                                                </tr>

                                            ))}
                                            <tr>
                                                <td className="font-bold">
                                                    {t('projectStats.expenses.table.workTypeTotal')}
                                                </td>
                                                <Fragment>
                                                {this.state.projectStats.workTypes.map((wt, wtI) => (
                                                    <td key={wtI} className="text-right">
                                                        {this.state.projectStats.expensesPerWorkType.find(el => el[0] === wt[0]) ? (
                                                            <span>{(currencyFormatter.format((this.state.projectStats.expensesPerWorkType.find(el => el[0] === wt[0]))[1]))}</span>
                                                        ) : (
                                                            <span>{currencyFormatter.format(0)}</span>
                                                        )}
                                                    </td>
                                                ))}
                                                <td className="text-right font-bold">
                                                    {currencyFormatter.format(this.state.projectStats.expensesForProject)}
                                                </td>
                                                </Fragment>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row m-t">
                            <div className="col-xs-12">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h4>{t('projectStats.hoursPerWorkTypePerDay.title')}</h4>
                                    </div>
                                    <div className="ibox-content">
                                        <table className="table table-bordered table-striped">
                                            <thead>
                                            <tr>
                                                <th>
                                                    {t('projectStats.hoursPerWorkTypePerDay.table.workType')}
                                                </th>
                                                {hoursPerWorkTypePerDayDays.map((day, dayI) => (
                                                    <th key={dayI}>
                                                        {day.format('DD.MM.YY')}
                                                    </th>
                                                ))}
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {hoursPerWorkTypePerDayWorkTypes.map((wt, wtI) => (
                                                <tr key={wtI}>
                                                    <td>
                                                        {wt}
                                                    </td>
                                                    {hoursPerWorkTypePerDayDays.map((day, dayI) => (
                                                        <td key={(wtI + 1) * dayI}>
                                                            {this.state.projectStats.hoursPerWorkTypePerDay.find(el => el[0] === wt && el[1] === day.format('YYYY-MM-DD')) ? this.state.projectStats.hoursPerWorkTypePerDay.find(el => el[0] === wt && el[1] === day.format('YYYY-MM-DD'))[2] : '0'}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row m-t">
                            <div className="col-xs-12">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h4>{t('projectStats.slotsPerHourPerWorkType.title')}</h4>
                                    </div>
                                    <div className="ibox-content">
                                        <div id="plot-slotsPerHourPerWorkType"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        company: state.company
    }
};

export default connect(mapStateToProps,null)(translate()(ProjectStats));
